module.exports = __webpack_public_path__ + "static/img/not-done-start-guide.083bf10a.svg";